import { Link } from "react-router-dom";
import { getEstDateTime } from "../utilities/util";
import { useEffect, useState } from "react";

const Footer = () => {
  const [time, setTime] = useState(getEstDateTime().toLocaleString());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(getEstDateTime().toLocaleString());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [])
  
  return (
    <footer className="bg-white/10 backdrop-blur-md text-white border-t border-white/20 shadow-inner mt-5">
      <div className="max-w-7xl mx-auto text-center py-5 px-4">
        <p className="text-sm text-gray-500">
          &copy; {getEstDateTime().getFullYear()} <span className="text-yellow-300 font-medium">Delight Long Island LLC</span>. All rights reserved.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 mt-3 text-sm">
          {/* <Link 
            to="/terms-and-conditions" 
            className="hover:text-yellow-300 transition duration-300 ease-in-out transform hover:scale-105"
          >
            Terms & Conditions
          </Link> */}
          <Link 
            to="/privacy-policy" 
            className="hover:text-yellow-400 text-gray-800 transition duration-300 ease-in-out transform hover:scale-105"
          >
            Privacy Policy
          </Link>
          {/* <Link 
            to="/contact" 
            className="hover:text-yellow-300 transition duration-300 ease-in-out transform hover:scale-105"
          >
            Contact Us
          </Link> */}
        </div>
      </div>
      <div className="text-center py-3 text-sm text-gray-800">
        <p>
          Current Time: {time} 
        </p>
      </div>
    </footer>
  );
};

export default Footer;
